import React from "react";
import { useTranslation } from "react-i18next";
import { FiRefreshCcw } from "react-icons/fi";
import { IoMdInformationCircleOutline } from "react-icons/io";
import {
  BlueLedSolo,
  GreenLedSolo,
  RedLedSolo,
  YellowLedSolo,
} from "../../Team/userCard/Led";
import InputForms from "../../UiComponents/forms/InputForms";
import styles from "./HeaderArrayCertificat.module.scss";
const HeaderArrayCertifcat = ({ searchCabCertif, setSearchCabCertif }) => {
  const { t } = useTranslation();


  return (
    <div className={styles.container}>
      <div className={styles.containerSearch}>
        <InputForms
          type={"text"}
          placeholder={t("calibration.search_certificate")}
          value={searchCabCertif}
          onChange={(e) => setSearchCabCertif(e.target.value.toLowerCase())}
          paddingLeft={'10px'}
        />
        {searchCabCertif !== "" && (
          <FiRefreshCcw
            className={styles.refreshSvg}
            onClick={() => setSearchCabCertif("")}
          />
        )}

        <div className={styles.infoIconWrapper}>
          <IoMdInformationCircleOutline
            className={styles.infosLedCircle}
            size={"24px"}
          />
          <div className={styles.containerCodeLed}>
            <div className={styles.colorCodeLed}>
              <GreenLedSolo label={t("calibration.up_to_date")} />
              <h3>{t("calibration.calibration_up_to_date")}</h3>
            </div>
            <div className={styles.colorCodeLed}>
              <YellowLedSolo label={t("calibration.soon")} />
              <h3>{t("calibration.calibration_soon")}</h3>
            </div>
            <div className={styles.colorCodeLed}>
              <RedLedSolo label={t("calibration.overdue")} />
              <h3>{t("calibration.calibration_overdue")}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderArrayCertifcat;
